import React from "react"
import styled from "styled-components"
import { useFormContext } from "react-hook-form"

const VisibleCheckbox = ({ checked, size }) => (
  <StyledCheckbox checked={checked} size={size}>
    <Icon viewBox="0 0 24 24">
      <polyline points="20 6 9 17 4 12" />
    </Icon>
  </StyledCheckbox>
)

export const Checkbox = ({ checked, size = null, ...props }) => (
  <CheckboxContainer>
    <HiddenCheckbox checked={checked} {...props} />
    <VisibleCheckbox checked={checked} size={size} />
  </CheckboxContainer>
)

// Tutorial: https://medium.com/@colebemis/building-a-checkbox-component-with-react-and-styled-components-8d3aa1d826dd
// Notably, Checkbox component must be wrapped by a label element.
export const FormCheckbox = ({ checked, size = null, ...props }) => {
  const { errors, register } = useFormContext()

  return (
    <label>
      <CheckboxContainer>
        <HiddenCheckbox checked={checked} errors={errors} ref={register} {...props} />
        <VisibleCheckbox checked={checked} size={size} />
      </CheckboxContainer>
    </label>
  )
}

const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  // Hide checkbox visually but remain accessible to screen readers.
  // Source: https://polished.js.org/docs/#hidevisually
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const Icon = styled.svg`
  fill: none;
  stroke: ${(props) => props.theme.checkboxCheckColor};
  stroke-width: 2px;
`

const StyledCheckbox = styled.div`
  cursor: pointer;
  display: inline-block;
  width: ${(props) => (props.size ? props.size : "32px")};
  height: ${(props) => (props.size ? props.size : "32px")};
  background: ${(props) =>
    props.checked ? props.theme.checkedCheckboxBackgroundColor : props.theme.checkboxBackgroundColor || "#ffffff"};
  border-radius: 3px;
  border-color: ${(props) => props.theme.checkboxBorderColor || "#e48400"};
  border-width: 2px;
  border-style: solid;
  transition: all 150ms;
  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px 0;
  }
  ${Icon} {
    visibility: ${(props) => (props.checked ? "visible" : "hidden")};
  }
  :hover {
    border-color: ${(props) => props.theme.hoverBorderColor};
    background: ${(props) => props.checked && props.theme.hoverCheckboxBackgroundColor};
    ${Icon} {
      stroke: ${(props) => props.theme.hoverCheckColor};
    }
  }
`

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`
